import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "openQRCode" }
const _hoisted_2 = { class: "openQRCode__header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.showQrCode)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModal')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "openQRCode__header-img",
                src: _imports_0,
                alt: "Close Modal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
              })
            ]),
            _createElementVNode("form", null, [
              (_ctx.idActiveDelivery && _ctx.showOnlyDeliveryId)
                ? (_openBlock(), _createBlock(_component_Input, {
                    key: 0,
                    type: "text",
                    value: _ctx.idActiveDelivery,
                    title: _ctx.$t('kolliID'),
                    disabled: ""
                  }, null, 8, ["value", "title"]))
                : _createCommentVNode("", true),
              (_ctx.deliveryQRCode && _ctx.showOnlyDeliveryQRCode)
                ? (_openBlock(), _createBlock(_component_Input, {
                    key: 1,
                    type: "text",
                    value: _ctx.deliveryQRCode.code,
                    title: _ctx.$t('kolliID'),
                    disabled: ""
                  }, null, 8, ["value", "title"]))
                : _createCommentVNode("", true),
              (_ctx.pharmacyEntryPin && _ctx.userBoxPin)
                ? (_openBlock(), _createBlock(_component_Input, {
                    key: 2,
                    type: "text",
                    value: `2:${_ctx.pharmacyEntryPin}:${_ctx.userBoxPin}`,
                    disabled: ""
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.idActiveDelivery && _ctx.showOnlyDeliveryId)
              ? (_openBlock(), _createBlock(_component_qrcode_vue, {
                  key: 0,
                  value: _ctx.idActiveDelivery,
                  size: 300,
                  level: "H"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (_ctx.deliveryQRCode && _ctx.showOnlyDeliveryQRCode)
              ? (_openBlock(), _createBlock(_component_qrcode_vue, {
                  key: 1,
                  value: _ctx.deliveryQRCode.code,
                  size: 300,
                  level: "H"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            (_ctx.pharmacyEntryPin && _ctx.userBoxPin)
              ? (_openBlock(), _createBlock(_component_qrcode_vue, {
                  key: 2,
                  value: `2:${_ctx.pharmacyEntryPin}:${_ctx.userBoxPin}`,
                  size: 300,
                  level: "H"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}